export const currencyFormat = num => {
	const parsed = parseInt(num, 10);
	const c =
		parsed.toString().indexOf('.') !== -1
			? parsed.toLocaleString()
			: parsed.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
	return c;
};
